<div class="col-lg-12 nopadding">
    <br/>
    @if(isLoadingResults){
    <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
    </div>}
    <p-table [columns]="gridColumns" [value]="Dataset" [paginator]="true" [resizableColumns]="true"
        alwaysShowPaginator="true" columnResizeMode="expand" appendTo="body" [totalRecords]="Dataset.length"
        paginatorPosition="both" sortMode="multiple" [rows]="constantService.DEFAULT_ROWSIZE"
        [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" selectionMode="single" [lazy]="false"
        showCurrentPageReport="true" [scrollable]="true" scrollHeight="70vh" #dt>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length">
                    {{constantService.NO_RECORDFOUND_MSG}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
                <th id="columnHeader" pResizableColumn [pSortableColumn]="col.field" [ngClass]="
            (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
                    {{ col.header == 'IsActive' ? 'IsActive [ALL FIRMs]' : col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
                @for(col of columns; track col.field + '-'+ $index) {
                <td class="ui-resizable-column" [ngClass]="col.header=='Action' ? 'text-center':''">
                    @if(col.header =='IsActive'){
                    <span>
                        <a (click)="isActiveChange(row[col.field],row)" appendTo="body" style="color: blue !important;cursor: pointer">{{row[col.field] == true ? 'True' : 'False' }}</a>
                    </span>
                    }
                    @if(col.header =='FirmIsActive'){
                    <span>
                        <a (click)="isFirmActiveChange(row[col.field],row)" appendTo="body" style="color: blue !important;cursor: pointer">{{row[col.field] == 1 ? 'True' : 'False'}}</a>
                    </span>
                    }
                    @if(col.header!='Action' && col.header !='IsActive' && col.header !='FirmIsActive'){
                    <span>
                        {{row[col.field]}}
                    </span>
                    }
                </td>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
        </ng-template>
        <ng-template pTemplate="paginatorright">
            Total Records:{{ Dataset?.length == 0 ? 0 : Dataset?.length }}
        </ng-template>
    </p-table>
    <br />
</div>
